import React from 'react';

const FormMessage = ({ status, data, ErrorIcon, SuccessIcon }) => {
  const createInvalidMessage = () => {
    const invalidFields = data.fields.filter((field) => !field.validity.valid);

    let message = `${data.message.invalid} `;

    invalidFields.forEach((field, index) => {
      if (index === invalidFields.length - 2) {
        message += `${field.label} ${data.message.conjunction} `;
      } else if (index === invalidFields.length - 1) {
        message += `${field.label}`;
      } else {
        message += `${field.label}, `;
      }
    });

    return message;
  };

  return (
    <div className={`mvp-mail-subscription__message mvp-mail-subscription__message--submit is-${status.toLowerCase()}`}>
      {status === 'SUCCESS' && (
        <>
          {/* <SuccessIcon className="icon-success" /> */}
          <p>{data.message.success}</p>
        </>
      )}

      {status === 'INVALID' && (
        <>
          {/* <ErrorIcon className="icon-error" /> */}
          <p>{createInvalidMessage()}</p>
        </>
      )}
      {status === 'ERROR' && (
        <>
          {/* <ErrorIcon className="icon-error" /> */}
          <p>{data.message.error}</p>
        </>
      )}
    </div>
  );
};

export default FormMessage;
